import createModelStore from "../../utils/createModelStore";
import Client from "../../services/Client";

const clients = createModelStore<Client.Model, "clients">("clients");

export default clients;
